module.exports = __webpack_public_path__ + "img/123.2.35932944.png";